import React from 'react';
import { Grid, Segment, Label, Button } from 'semantic-ui-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

export default class Rincianbp extends React.Component {

   // removeBp(item, i) {
   //    confirmAlert({
   //       title: '',
   //       message: 'Benar akan dihapus?',
   //       buttons: [
   //         {
   //           label: 'Ya',
   //           onClick: () => this.props.removeBp(item, i)
   //         },
   //         {
   //           label: 'Tidak',
   //           onClick: () => false
   //         }
   //       ]
   //    })
   // }

   editBp(item, i) {
      console.log(i)
      console.log(item)
      this.props.editBp(item, i);
   }

   detailBp(item, i){
      this.props.detailBp(item, i)
   }

   render() {
      return(
         <Grid>
            <Grid.Column>
               <Segment.Group>
                  {this.props.data.bp.map((item, i)=>(
                     <Segment key={i} secondary={i%2===0}>
                        <Button.Group size='mini' floated='right'>
                           <Button color='green' onClick={()=>{this.editBp(item, i)}} icon='pencil' />
                           <Button color='blue' icon='block layout' onClick={()=>this.detailBp(item,i)} />
                           {/* {this.props.data.bp.length > 1 &&
                              <Button color='red' onClick={()=>{this.removeBp(item, i)}} icon='trash' />
                           } */}
                           
                        </Button.Group>   
                        
                        {i+1}.&nbsp;&nbsp;
                        <Label circular color="violet">
                           {item.no_bukti}
                        </Label>
                     </Segment>
                  ))}
               </Segment.Group>
            </Grid.Column>
         </Grid>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/Rincianbp.js